<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="notentransaction-list">
            <h2>Offene Notenrückgaben</h2>
            <div class="notentransaction-filter">
                <b-row>
                    <b-col>
                        <template v-if="allowSVSwitch">
                            <b-input-group :size="size">
                                <b-input-group-prepend is-text>Rolle auswählen:</b-input-group-prepend>
                                <b-select
                                    v-model="filter.sv.value"
                                    :options="filter.sv.options"
                                    :disabled="filter.sv.busy"
                                    :size="size"
                                ></b-select>
                            </b-input-group>
                            <hr />
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="4">
                        <b-form-group
                            :label-size="size"
                            label="Status Notentransfers (aktiv/abgeschrieben)"
                            label-for="filterShow"
                        >
                            <b-select
                                id="filterShow"
                                :options="filter.show.options"
                                v-model="filter.show.value"
                                :size="size"
                            ></b-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group :label-size="size" label="Konzert" label-for="filterWerk">
                            <FilteredSelect
                                :size="size"
                                :busy="filter.werke.busy"
                                :options="filter.werke.options"
                                v-model="filter.werke.value"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group :label-size="size" label="Note" label-for="fitlerNote">
                            <FilteredSelect
                                :size="size"
                                :busy="filter.noten.busy"
                                :options="filter.noten.options"
                                v-model="filter.noten.value"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-button
                            :size="size"
                            class="ml-auto d-block"
                            @click="clearFilter"
                        >Filter zurücksetzen</b-button>
                    </b-col>
                </b-row>
            </div>
            <hr />
            <b-row>
                <b-col>
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        variant="warning"
                        :disabled="printing.busy"
                        @click="printAllDuring()"
                    >
                        Mahnungen drucken
                        <template v-if="printing.busy">
                            <Spinner small variant="dark" />
                        </template>
                        <template v-else>
                            <font-awesome-icon icon="exclamation-triangle" />
                        </template>
                    </b-button>
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        class="ml-2"
                        variant="danger"
                        :disabled="printing.busy"
                        @click="printAllBilling()"
                    >
                        Rechnungen drucken
                        <template v-if="printing.busy">
                            <Spinner small variant="light" />
                        </template>
                        <template v-else>
                            <font-awesome-icon icon="receipt" />
                        </template>
                    </b-button>
                </b-col>
            </b-row>
            <hr />
            <Table
                bordered
                striped
                responsive
                :small="size"
                showFilter
                :fields="fields"
                :items="items"
                :isBusy="busy"
                :refresh="refresh"
                tableClass="main-table"
                sortBy="mitglied"
                busyText="Lädt Notentransaktionen..."
                emptyText="Keine offenen Notentransaktionen gefunden"
            >
                <template v-slot:detail="{row: row}">
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        variant="secondary"
                        @click="showDetails(row)"
                        class="mv-table-action-btn mr-1 mv-nowrap"
                    >
                        Details
                        <font-awesome-icon
                            :icon="row.item._showDetails ? 'caret-down' : 'caret-right'"
                            class="ml-1"
                        />
                    </b-button>
                </template>

                <template v-slot:row-details="{row: row}">
                    <Table
                        tableClass="inner-table"
                        bordered
                        small
                        :fields="subfields"
                        :items="row.item.transactions"
                    >
                        <template v-slot:konzert="{row: row}">{{row.value.bezeichnung}}</template>

                        <template v-slot:issued="{row: row}">-{{row.value}}</template>

                        <template v-slot:returned="{row: row}">
                            <template v-if="row.value > 0">{{row.value}}</template>
                            <template v-else>&nbsp;</template>
                        </template>

                        <template v-slot:total="{row: row}">
                            <template v-if="parseInt(row.item.total) > 0">-{{row.value}}</template>
                            <template v-else>{{row.value}}</template>
                        </template>

                        <template
                            v-slot:sv="{row: row}"
                        >{{row.item.sv_vorname + " " + row.item.sv_name}}</template>

                        <template v-slot:actions="{ row: row }">
                            <template v-if="checkRight('write')">
                                <template
                                    v-if="isPrintingBusy(row.sv_id, row.werk_id, row.noten_id, row.notentyp, row.id)"
                                >
                                    <Spinner small />
                                </template>
                                <template v-else>
                                    <b-dropdown text="Aktionen" :size="size" dropleft>
                                        <b-dropdown-item
                                            v-if="checkRight('write')"
                                            :to="{path: '/notenverwaltung/notentransfer/mitglieder', query: {sv_id: row.sv_id, werk_id: row.werk_id, noten_id: row.noten_id, notentyp: row.notentyp}, hash: '#' + row.id}"
                                        >
                                            <font-awesome-icon
                                                icon="exchange-alt"
                                                class="text-primary mr-1"
                                            />Zum Notentransfer
                                        </b-dropdown-item>
                                        <b-dropdown-item
                                            v-if="checkRight('write')"
                                            :disabled="printing.busy"
                                            @click="printDuring(row.sv_id, row.werk_id, row.noten_id, row.notentyp, row.id)"
                                        >
                                            <font-awesome-icon
                                                icon="exclamation-triangle"
                                                class="text-warning mr-1"
                                            />Mahnung drucken
                                        </b-dropdown-item>
                                        <b-dropdown-item
                                            v-if="checkRight('write')"
                                            :disabled="printing.busy"
                                            @click="printBilling(row.sv_id, row.werk_id, row.noten_id, row.notentyp, row.id)"
                                        >
                                            <font-awesome-icon
                                                icon="receipt"
                                                class="text-danger mr-1"
                                            />Rechnung drucken
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </template>
                            </template>
                            <template v-else>&nbsp;</template>
                        </template>

                        <template v-slot:custom-foot="{data: data}">
                            <template v-if="data.items.length > 1">
                                <b-tr>
                                    <b-td colspan="6" class="text-right font-weight-bold">Summen:</b-td>
                                    <b-td
                                        class="table-danger text-right"
                                    >-{{calcSum(data, "issued")}}</b-td>
                                    <b-td
                                        class="table-success text-right"
                                    >{{calcSum(data, "returned")}}</b-td>
                                    <b-th class="text-right">{{calcSum(data, "total")}}</b-th>
                                </b-tr>
                            </template>
                        </template>
                    </Table>
                </template>

                <template v-slot:mitglied="{row: row}">{{row.item.vorname + " " + row.item.name}}</template>

                <template v-slot:total="{row: row}">{{row.value}}</template>

                <template v-slot:custom-foot="{data: data}">
                    <b-tr>
                        <b-td colspan="3" class="text-right font-weight-bold">Summen:</b-td>
                        <b-th class="table-warning text-right">{{calcSum(data, "total")}}</b-th>
                    </b-tr>
                </template>
            </Table>
        </div>
    </MainContainer>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Validation from "@/mixins/Validation/Validation";
import User from "@/mixins/User/User";

import NotenverwaltungCommon from "@/mixins/NotenverwaltungCommon/NotenverwaltungCommon";
import { ApiFactory } from "@/api/ApiFactory.js";
import { BlobUtil } from "@/utils/BlobUtil.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import FilteredSelect from "@/components/FilteredSelect/FilteredSelect";
import Spinner from "@/components/Spinner/Spinner";

import "./NotenTransactionList.scss";

const NotenTransactionsApi = ApiFactory.get("notentransactions");
const NotenverwaltungApi = ApiFactory.get("notenverwaltung");
const NotentransferMitgliederApi = ApiFactory.get("notentransferMitglieder");
const WerkeApi = ApiFactory.get("werke");

export default {
    name: "NotenTransactionList",
    mixins: [CommonView, Size, Validation, NotenverwaltungCommon, User],
    components: {
        MainContainer,
        Table,
        FilteredSelect,
        Spinner
    },
    data() {
        return {
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "detail",
                    label: "Details"
                },
                {
                    key: "mitglied",
                    label: "Mitglied",
                    sortable: true
                },
                {
                    key: "total",
                    label: "offen (gesamt)",
                    thClass: "text-center",
                    class: "text-right font-weight-bold",
                    variant: "warning"
                }
            ],
            subfields: [
                {
                    key: "konzert",
                    label: "Konzert"
                },
                {
                    key: "noten_werk",
                    label: "Werk"
                },
                {
                    key: "noten_komponist",
                    label: "Komponist"
                },
                {
                    key: "noten_ausgabe",
                    label: "Ausgabe"
                },
                {
                    key: "notentyp_desc",
                    label: "Notenart"
                },
                {
                    key: "sv",
                    label: "geliehen von"
                },
                {
                    key: "issued",
                    label: "AUS",
                    class: "text-right",
                    thClass: "text-center",
                    variant: "danger"
                },
                {
                    key: "returned",
                    label: "RÜCK",
                    class: "text-right",
                    thClass: "text-center",
                    variant: "success"
                },
                {
                    key: "total",
                    label: "Summe",
                    thClass: "text-center",
                    class: "text-right font-weight-bold"
                },
                {
                    key: "actions",
                    label: "Funktionen",
                    class: "text-center"
                }
            ],
            allowSVSwitch: false,
            api: NotenTransactionsApi,
            prefetch: false,
            refresh: false,
            filter: {
                show: {
                    value: "open",
                    options: [
                        {
                            value: "open",
                            text: "offene Rückgaben (aktive Noten)"
                        },
                        {
                            value: "closed",
                            text: "offene Rückgaben (abgeschriebe Noten)"
                        },
                        { value: "all", text: "alle" }
                    ]
                },
                werke: {
                    value: null,
                    data: [],
                    options: [],
                    busy: false
                },
                sv: {
                    value: null,
                    data: [],
                    options: [],
                    busy: false
                },
                noten: {
                    value: null,
                    data: [],
                    options: [],
                    busy: false
                }
            },
            printing: {
                busy: false,
                sv_id: null,
                werk_id: null,
                noten_id: null,
                notentyp: null,
                id: null
            }
        };
    },
    computed: {
        svId() {
            return this.allowSVSwitch ? this.filter.sv.value : this.userId;
        },
        filterRendered() {
            return {
                show: this.filter.show.value,
                filter: {
                    werk_id: this.filter.werke.value,
                    sv_id: this.svId,
                    noten_id: this.filter.noten.value
                }
            };
        }
    },
    async created() {
        await this.fetchSV();
        this.fetchWerke();
        this.fetchNoten();
    },
    watch: {
        filterRendered: {
            handler() {
                this.fetch();
            },
            deep: true
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.get(this.filterRendered);
            if (response.ok) {
                var items = response.json.collection;
                if (items) {
                    items = items.map(item => this.process(item));
                    this.items = items;
                } else {
                    this.items = [];
                }
                this.registerRights(response);
            }
            this.busy = false;
        },
        process(item, considerDetails = true) {
            if (considerDetails) {
                item._showDetails = true;
            }
            return item;
        },
        async fetchWerke() {
            this.filter.werke.busy = true;
            const response = await WerkeApi.get();
            if (response.ok) {
                this.filter.werke.data = response.json.collection;
                this.filter.werke.options = response.json.collection.map(
                    item => {
                        return {
                            value: item.id,
                            text: item.bezeichnung
                        };
                    }
                );
            }
            this.filter.werke.busy = false;
        },
        async fetchSV() {
            this.filter.sv.busy = true;
            const response = await NotenverwaltungApi.getSV();
            if (response.ok) {
                var data = response.json.collection;
                var options = data.map(item => {
                    return {
                        value: item.id,
                        text: item.vorname + " " + item.name
                    };
                });
                options.unshift({
                    value: null,
                    text: "Alle Stimmvertreter*innen"
                });

                this.filter.sv.data = data;
                this.filter.sv.options = options;
                this.allowSVSwitch = true;
            }
            this.filter.sv.busy = false;
        },
        async fetchNoten() {
            this.filter.noten.busy = true;
            const response = await NotenverwaltungApi.get();
            if (response.ok) {
                var data = response.json.collection;
                var options = data.map(item => {
                    return {
                        value: item.id,
                        text: this.getNotenDescription(
                            item.werk,
                            item.komponist,
                            item.ausgabe
                        )
                    };
                });
                this.filter.noten.data = data;
                this.filter.noten.options = options;
            }
            this.filter.noten.busy = false;
        },
        showDetails(row) {
            row.item._showDetails = !row.item._showDetails;
        },
        clearFilter() {
            Object.keys(this.filter).forEach(key => {
                if (key === "show") {
                    this.filter[key].value = "open";
                } else {
                    this.filter[key].value = null;
                }
            });
        },
        calcSum(data, type) {
            var sum = 0;
            data.items.forEach(item => {
                sum += parseInt(item[type]);
            });
            return sum;
        },
        async printDuring(sv_id, werk_id, noten_id, notentyp, id = null) {
            this.setPrintingState(sv_id, werk_id, noten_id, notentyp, id);
            const response = await NotentransferMitgliederApi.getDuring(
                sv_id,
                werk_id,
                noten_id,
                notentyp,
                id
            );
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Mahnung.pdf");
            }
            this.clearPrintingState();
        },
        async printAllDuring() {
            this.printing.busy = true;
            const response = await NotenTransactionsApi.getDuring({
                show: this.filter.show.value,
                filter: {
                    werk_id: this.filter.werke.value,
                    sv_id: this.svId,
                    noten_id: this.filter.noten.value
                }
            });
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Mahnungen.pdf");
            }
            this.printing.busy = false;
        },
        async printBilling(sv_id, werk_id, noten_id, notentyp, id = null) {
            this.setPrintingState(sv_id, werk_id, noten_id, notentyp, id);
            const response = await NotentransferMitgliederApi.getBilling(
                sv_id,
                werk_id,
                noten_id,
                notentyp,
                id
            );
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Rechnung.pdf");
            }
            this.clearPrintingState();
        },
        async printAllBilling() {
            this.printing.busy = true;
            const response = await NotenTransactionsApi.getBilling({
                show: this.filter.show.value,
                filter: {
                    werk_id: this.filter.werke.value,
                    sv_id: this.svId,
                    noten_id: this.filter.noten.value
                }
            });
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Rechnungen.pdf");
            }
            this.printing.busy = false;
        },
        setPrintingState(sv_id, werk_id, noten_id, notentyp, id) {
            this.printing = {
                busy: this.printing.busy,
                sv_id: sv_id,
                werk_id: werk_id,
                noten_id: noten_id,
                notentyp: notentyp,
                id: id
            };
        },
        clearPrintingState() {
            this.printing = {
                busy: this.printing.busy,
                sv_id: null,
                werk_id: null,
                noten_id: null,
                notentyp: null,
                id: null
            };
        },
        isPrintingBusy(sv_id, werk_id, noten_id, notentyp, id) {
            return (
                this.printing.sv_id === sv_id &&
                this.printing.werk_id === werk_id &&
                this.printing.noten_id === noten_id &&
                this.printing.notentyp === notentyp &&
                this.printing.id === id
            );
        }
    }
};
</script>